(ns app.front.form.ventilation-render
  (:require [app.front.form.render :as fr]
            [app.front.ui :as ui]
            [app.front.util :as futil :refer [for-all]]
            [app.front.view.system-of-units.toggle :as sou-toggle]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [goog.string :as gstr]
            [goog.string.format]
            [reagent.core :as r]))


;;
;; Automatic calculator fields:
;;


(defn- parse-number [s step]
  (if (and (number? step) (< step 1))
    (let [n (js/parseFloat s 10)]
      (when-not (js/isNaN n)
        n))
    (futil/parse-int s)))


(defn- visible? [ctx current-id {:keys [condition]}]
  (if-let [field-checks (-> condition :field)]
    (every? (fn [[field-name required-value]]
              (let [field (fr/child-of current-id field-name ctx)]
                (= (:form.field/value field) required-value)))
            field-checks)
    true))


(defn ventilation-input-calculator [{:keys [form-field target-id disabled?] :as ctx} attr current-id]
  (r/with-let [value (r/atom (when-not (str/blank? (:form.field/value form-field))
                               (:form.field/value form-field)))]
    (let [on-change (fn [e]
                      (let [v                    (-> e .-target .-value (parse-number (:step attr)))
                            new-value            (if (or (nil? v)
                                                         (< v 0))
                                                   (reset! value 0)
                                                   (reset! value v))
                            result-field         (fr/child-of current-id (-> attr :result-field) ctx)
                            total-field          (fr/child-of current-id (-> attr :total-field) ctx)
                            final-field          (fr/child-of current-id (-> attr :final-field) ctx)
                            multiplication-value (parse-number
                                                   (* new-value (:metric-multiplier attr))
                                                   (:step attr))
                            sums                 (vec (for-all [value (:sum-values attr)]
                                                        (if (not (str/blank? (get (fr/child-of current-id value ctx) :form.field/value)))
                                                          (get (fr/child-of current-id value ctx) :form.field/value)
                                                          0)))
                            sum-value            (+ multiplication-value (apply + sums))
                            subtraction          (get (fr/child-of current-id (-> attr :subtraction-field) ctx) :form.field/value)
                            final-value          (if (not (str/blank? subtraction))
                                                   (- sum-value subtraction)
                                                   "")]
                        (>evt [:app.front.view.form-util/update-form-field
                               target-id
                               {:form-id       (:form-id ctx)
                                :form-field-id (:db/id form-field)
                                :new-value     new-value
                                :field-key     (:form.field/id form-field)}])
                        (>evt [:app.front.view.form-util/update-form-field
                               target-id
                               {:form-id       (:form-id ctx)
                                :form-field-id (:db/id result-field)
                                :new-value     multiplication-value
                                :field-key     (:form.field/id result-field)}])
                        (>evt [:app.front.view.form-util/update-form-field
                               target-id
                               {:form-id       (:form-id ctx)
                                :form-field-id (:db/id total-field)
                                :new-value     sum-value
                                :field-key     (:form.field/id total-field)}])
                        (>evt [:app.front.view.form-util/update-form-field
                               target-id
                               {:form-id       (:form-id ctx)
                                :form-field-id (:db/id final-field)
                                :new-value     (if (not (str/blank? final-value))
                                                 final-value
                                                 sum-value)
                                :field-key     (:form.field/id final-field)}])))]
      [:div.number-input-wrapper
       [fr/number-input {:id            (fr/field-dom-id ctx form-field attr)
                         :default-value (if (number? @value)
                                          @value
                                          (:default-value attr))
                         :label-text    ""
                         :hide-label    true
                         :min           (:min attr)
                         :placeholder   0
                         :on-change     on-change
                         :disabled      (boolean disabled?)}]])))


(defmethod fr/render :ventilation-input-calculator [ctx _ current-id [_ attr]]
  (when-let [form-field (fr/child-of current-id (-> attr :field) ctx)]
    (when (visible? ctx current-id attr)
      [ventilation-input-calculator (assoc ctx :form-field form-field) attr current-id])))


(defn ventilation-select-calculator [{:keys [target-id form-field tr] :as ctx} attr current-id]
  (r/with-let [value (r/atom (if (not (str/blank? (:form.field/value form-field)))
                               (:form.field/value form-field)
                               (:default-value form-field)))]
    (let [on-change (fn [e]
                      (let [v                 (-> e .-target .-value)
                            subtraction       (get (:subtraction attr) v)
                            final-field       (fr/child-of current-id (-> attr :final-field) ctx)
                            subtraction-field (fr/child-of current-id (-> attr :subtraction-field) ctx)
                            total-field       (fr/child-of current-id (-> attr :total-field) ctx)
                            old-total         (:form.field/value total-field)
                            final-value       (if (str/blank? subtraction)
                                                ""
                                                (- old-total subtraction))]
                        (>evt [:app.front.view.form-util/update-form-field
                               target-id
                               {:form-id       (:form-id ctx)
                                :form-field-id (:db/id form-field)
                                :new-value     v
                                :field-key     (:form.field/id form-field)}])
                        (>evt [:app.front.view.form-util/update-form-field
                               target-id
                               {:form-id       (:form-id ctx)
                                :form-field-id (:db/id subtraction-field)
                                :new-value     subtraction
                                :field-key     (:form.field/id subtraction-field)}])
                        (>evt [:app.front.view.form-util/update-form-field
                               target-id
                               {:form-id       (:form-id ctx)
                                :form-field-id (:db/id final-field)
                                :new-value     (if (str/blank? final-value)
                                                 old-total
                                                 final-value)
                                :field-key     (:form.field/id final-field)}])))
          options   (->> (:form.field/valid-values attr)
                         (map (fn [v]
                                [v (tr [(keyword v) v])]))
                         (sort-by second))]
      (into (cc/select {:id            (fr/field-dom-id ctx form-field attr)
                        :label-text    ""
                        :hide-label    true
                        :on-change     on-change
                        :default-value (if @value
                                         @value
                                         (:default-value attr))}
                       (ui/placeholder-select-item tr :none {:disabled true}))
            (for [[value text] options]
              (cc/select-item {:text  text
                               :value value}))))))


(defmethod fr/render :ventilation-select-calculator [ctx _ current-id [_ attr]]
  (when-let [form-field (fr/child-of current-id (-> attr :field) ctx)]
    (when (visible? ctx current-id attr)
      [ventilation-select-calculator (assoc ctx :form-field form-field) attr current-id])))


(defmethod fr/render :ventilation-calculator [ctx _ current-id [_ attr]]
  (when-let [form-field (fr/child-of current-id (-> attr :field) ctx)]
    (when (fr/field-updated? (:form-id ctx) (:db/id form-field))
      ;; Updated-class that will effect on labels of text-fields
      {:class "updated"})
    [:div.number-input-wrapper
     (cc/text-input {:key           (str (:id attr)
                                         (:form.field/value form-field)
                                         (<sub [::sou-toggle/selected-system-of-units]))
                     :id            (fr/field-dom-id ctx form-field attr)
                     :disabled      true
                     :label-text    (str (:label attr))
                     :hide-label    true
                     :class-name    (if (:class-name attr)
                                      (:class-name attr)
                                      "form-page__input")
                     :default-value (let [display-value (if (= (<sub [::sou-toggle/selected-system-of-units]) :metric)
                                                          ;; TODO get rid of form-specific multipliers
                                                          (:form.field/value form-field)
                                                          ;; Value is always stored as metric
                                                          (-> (:form.field/value form-field)
                                                              (/ (:metric-multiplier attr))
                                                              (* (:imperial-multiplier attr))))]
                                      (if (number? display-value)
                                        (if (int? display-value)
                                          (str display-value)
                                          (gstr/format "%.1f" display-value))
                                        (:default-value attr)))})
     [:div.input-unit (<sub [::sou-toggle/label-in-selected-system (:unit attr)])]]))
